export default __webpack_public_path__ + "static/media/Highlord's Cloak of Swirling Mist.28709c62.jpg";